/*module.exports = {
    updateConfig: function(analyticsData) {
        let analyticsConfig = {
            pageInfo: {
                // Global App level (pulls from config)
                Country_Language: config.language,
                SiteIdentifier: config.site_identifier,
                PNL: config.pnl,
                Product: config.product,
                PageKind: config.page_kind,
                CustomerType: config.customer_type,

                // Screen/Interaction level (pulls from component)
                Device: analyticsData.device,
                ClientName: analyticsData.client_name,
                PageFunction: analyticsData.page_function,
                PageSubFunction: analyticsData.page_sub_function,
                pageName: analyticsData.page_name
            }
        };
        // UpdateBootstrap config
        window._SFDDL = analyticsConfig;
    },
    triggerBootstrap: function() {
		// tell Ensighten SDK that _SFDDL has been updated
		try {
			window.Bootstrapper.ensEvent.trigger("SPA-PageLoad");
		} catch (e) {
			console.error(e);
		}
    }
};
*/

class Analytics {
    constructor(data, config) {
        this.analyticsConfig = {
            pageInfo: {
                // Global App level (pulls from config)
                SiteIdentifier: config.site_identifier,
                PNL: config.pnl,
                Product: config.product,
                PageKind: config.page_kind,
                CustomerType: config.customer_type,
                ClientName: config.client_name,

                // Screen/Interaction level (pulls from component)
                Device: data.device,
                PageFunction: data.page_function,
                PageSubFunction: data.page_sub_function,
                pageName: data.page_name,
                Country_Language: data.country_language
            }
        };
        // UpdateBootstrap config
        window._SFDDL = this.analyticsConfig;
    }

    triggerBootstrap() {
        // tell Ensighten SDK that _SFDDL has been updated
        try {
            window.Bootstrapper.ensEvent.trigger("SPA-PageLoad");
        } catch (e) {
            console.error(e);
        }
    }
}

export default Analytics;
